import { styled } from '@mui/material';
import { Button } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledTypography } from '../styles';

export const HeroSectionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'stretch',
  width: '100%',
  gap: theme.spacing(12),
  padding: theme.spacing(14, 0, 7, 0),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(5, 0),
  },
}));

export const HeroSectionColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',

  width: '100%',
  gap: theme.spacing(2),
}));

export const LocationsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: theme.spacing(2),
  gap: theme.spacing(3),
}));

export const StyledJobDescription = styled(StyledTypography)(({ theme }) => ({
  lineHeight: 1.5,
  marginTop: theme.spacing(2),
}));

export const StyledImage = styled('img')(() => ({
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
}));

export const SalariesWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '95%',
  alignSelf: 'center',
});
export const StyledButton = styled(Button)(({ theme }) => ({
  width: '95%',
  alignSelf: 'center',
  marginTop: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
